// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--6SoYXv","video":"video--Jhaa6d","facebook_embed":"facebook_embed--udhXm-","facebookEmbed":"facebook_embed--udhXm-"};